import { render, staticRenderFns } from "./Obstetric.vue?vue&type=template&id=997e4c26&scoped=true"
import script from "./Obstetric.vue?vue&type=script&lang=js"
export * from "./Obstetric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997e4c26",
  null
  
)

export default component.exports